var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTreeChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 1.75C3.15784 1.75 2.75 2.08376 2.75 2.66667V4.33333C2.75 4.91624 3.15784 5.25 3.5 5.25H12.5C12.8422 5.25 13.25 4.91624 13.25 4.33333V2.66667C13.25 2.08376 12.8422 1.75 12.5 1.75H3.5ZM1.25 2.66667C1.25 1.4079 2.18466 0.25 3.5 0.25H12.5C13.8153 0.25 14.75 1.4079 14.75 2.66667V4.33333C14.75 5.5921 13.8153 6.75 12.5 6.75H3.5C2.18466 6.75 1.25 5.5921 1.25 4.33333V2.66667Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.25C8.41421 5.25 8.75 5.58579 8.75 6V12C8.75 12.4142 8.41421 12.75 8 12.75C7.58579 12.75 7.25 12.4142 7.25 12V6C7.25 5.58579 7.58579 5.25 8 5.25Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 12.75V14.25H8.75V12.75H7.25ZM5.75 12.7222C5.75 11.909 6.40904 11.25 7.22225 11.25H8.77775C9.59096 11.25 10.25 11.909 10.25 12.7222V14.2778C10.25 15.091 9.59096 15.75 8.77775 15.75H7.22225C6.40904 15.75 5.75 15.091 5.75 14.2778V12.7222Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10.5601C2.25 9.34744 3.16428 8.25 4.42857 8.25H11.5714C12.8357 8.25 13.75 9.34744 13.75 10.5601V12C13.75 12.4142 13.4142 12.75 13 12.75C12.5858 12.75 12.25 12.4142 12.25 12V10.5601C12.25 10.0488 11.8857 9.75 11.5714 9.75H4.42857C4.11429 9.75 3.75 10.0488 3.75 10.5601V12C3.75 12.4142 3.41421 12.75 3 12.75C2.58579 12.75 2.25 12.4142 2.25 12V10.5601Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 12.75V14.25H14.25V12.75H12.75ZM11.25 12.7222C11.25 11.909 11.909 11.25 12.7222 11.25H14.2778C15.091 11.25 15.75 11.909 15.75 12.7222V14.2778C15.75 15.091 15.091 15.75 14.2778 15.75H12.7222C11.909 15.75 11.25 15.091 11.25 14.2778V12.7222Z",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 12.75V14.25H3.25V12.75H1.75ZM0.25 12.7222C0.25 11.909 0.909036 11.25 1.72225 11.25H3.27775C4.09096 11.25 4.75 11.909 4.75 12.7222V14.2778C4.75 15.091 4.09096 15.75 3.27775 15.75H1.72225C0.909036 15.75 0.25 15.091 0.25 14.2778V12.7222Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeChart);
export default __webpack_public_path__ + "static/media/icon-tree-chart.064439698e4d72e257f4cd05b619beb7.svg";
export { ForwardRef as ReactComponent };